import { ActionTypes, TypeKeys } from '../actions';

const getInitialState = (): SworkitState['userAssignments'] => {
  return {
    assignments: [],
  };
};

const userAssignments = (
  state = getInitialState(),
  action: ActionTypes
): UserAssignmentsState => {
  switch (action.type) {
    case TypeKeys.GET_USER_ASSIGNMENT_DATA: {
      return {
        ...state,
        assignments: action.userAssignments,
      };
    }
  }
  return state;
};
export default userAssignments;
